var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11117 6.49274L2.32601 0.707681C2.19221 0.573772 2.01359 0.5 1.82313 0.5C1.63268 0.5 1.45406 0.573772 1.32026 0.707681L0.894224 1.13361C0.616998 1.41116 0.616998 1.86224 0.894224 2.13936L5.75217 6.9973L0.888834 11.8606C0.75503 11.9945 0.681152 12.1731 0.681152 12.3634C0.681152 12.554 0.75503 12.7325 0.888834 12.8665L1.31487 13.2923C1.44878 13.4262 1.62729 13.5 1.81774 13.5C2.0082 13.5 2.18682 13.4262 2.32062 13.2923L8.11117 7.50198C8.24529 7.36764 8.31896 7.18829 8.31854 6.99762C8.31896 6.80622 8.24529 6.62697 8.11117 6.49274Z",
    fill: "#948FB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.0da3c56ebd2c110b02b6f7c0f4b15765.svg";
export { ForwardRef as ReactComponent };